// extracted by mini-css-extract-plugin
export default {"wrapper":"newsItem_wrapper__btJUT"};